import React from 'react';

export const DropPane = ({
  gaiaDropInbox,
  gaiaDropLoading,
  gaiaDropError,
  selectedDrop,
  setSelectedDrop,
  loadGaiaDropInbox,
  activeIdentity,
  displayGaiaID,
  t
}) => {
  return (
    <div className="chat-container" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <header className="reader-header" style={{ padding: '10px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div style={{ fontSize: '1.8rem' }}>📥</div>
          <div>
            <h3 style={{ fontSize: '1.1rem', fontWeight: 800 }}>GaiaDrop Inbox</h3>
            <span style={{ fontSize: '0.75rem', color: 'var(--text-secondary)' }}>
              {activeIdentity ? displayGaiaID(activeIdentity.GaiaID) : ''}
            </span>
          </div>
        </div>
        <button
          type="button"
          className="btn-primary"
          onClick={loadGaiaDropInbox}
          disabled={gaiaDropLoading}
          style={{ width: 'auto', padding: '0 16px', fontSize: '0.8rem' }}
        >
          {gaiaDropLoading ? t('drop_btn_decrypting') || 'Laden...' : t('drop_btn_load') || 'Laden / Entschlüsseln'}
        </button>
      </header>

      <div style={{ flex: 1, padding: '24px', overflowY: 'auto' }}>
        {gaiaDropLoading && (
          <div style={{ textAlign: 'center', color: 'var(--text-muted)', padding: '40px' }}>
            <div className="spinner" style={{ border: '3px solid rgba(0,0,0,0.1)', borderTop: '3px solid var(--accent-cyan)', borderRadius: '50%', width: '30px', height: '30px', animation: 'spin 1s linear infinite', margin: '0 auto 10px auto' }}></div>
            {t('drop_btn_decrypting') || 'Entschlüssele Posteingang...'}
          </div>
        )}

        {gaiaDropError && (
          <div className="glass-panel" style={{ padding: '20px', borderColor: 'var(--danger)', borderRadius: '8px', marginBottom: '20px' }}>
            <p style={{ color: 'var(--danger)', fontSize: '0.85rem' }}>{gaiaDropError}</p>
          </div>
        )}

        {!gaiaDropLoading && !gaiaDropError && selectedDrop ? (
          <div className="glass-panel" style={{ padding: '20px', borderRadius: '8px', border: '1px solid var(--border-color)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '15px' }}>
              <div>
                <span className="badge" style={{ background: 'var(--warning-glow)', color: 'var(--warning)', fontSize: '0.7rem', padding: '2px 8px', borderRadius: '4px', textTransform: 'uppercase', fontWeight: 'bold' }}>
                  {t('anonymous_sender') || 'Zero-Knowledge Drop'}
                </span>
                <h4 style={{ fontSize: '1.1rem', marginTop: '8px', fontWeight: 800 }}>
                  {selectedDrop.sender_label || t('anonymous_sender') || 'Anonymer Absender'}
                </h4>
                <small style={{ color: 'var(--text-muted)' }}>
                  {selectedDrop.created_at ? new Date(selectedDrop.created_at).toLocaleString() : t('time_unknown') || 'Zeitpunkt unbekannt'}
                </small>
              </div>
              <button type="button" className="btn-secondary" onClick={() => setSelectedDrop(null)}>
                {t('close') || 'Schließen'}
              </button>
            </div>

            <div style={{
              background: 'rgba(0,0,0,0.15)',
              padding: '16px',
              borderRadius: '6px',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-all',
              fontFamily: 'monospace',
              fontSize: '0.85rem',
              color: 'var(--text-primary)',
              lineHeight: '1.5',
              marginBottom: '20px',
              border: '1px solid var(--border-color)'
            }}>
              {selectedDrop.decrypted ? (typeof selectedDrop.decrypted === 'string' ? selectedDrop.decrypted : selectedDrop.decrypted.body) : (selectedDrop.decryptError || t('decrypt_failed') || 'Dekodierungsfehler')}
            </div>

            <div style={{ padding: '12px', background: 'rgba(0,242,254,0.05)', borderRadius: '6px', border: '1px dashed var(--accent-cyan)', fontSize: '0.75rem', color: 'var(--text-secondary)', lineHeight: '1.4' }}>
              <strong style={{ color: 'var(--accent-cyan)', display: 'block', marginBottom: '4px' }}>🛡️ Cryptographic Integrity Evidence (GaiaProof)</strong>
              <div>Drop ID: <code style={{ color: 'var(--text-primary)' }}>{selectedDrop.id}</code></div>
              <div>Proof Hash: <code style={{ color: 'var(--text-primary)' }}>{selectedDrop.payload_hash}</code></div>
              <div style={{ marginTop: '4px' }}>✓ Zero-Knowledge verifiziert: Keine Metadaten serverseitig aufgezeichnet.</div>
            </div>
          </div>
        ) : (
          !gaiaDropLoading && !gaiaDropError && (
            <div className="glass-panel" style={{ padding: '20px', borderRadius: '8px', border: '1px solid var(--border-color)', color: 'var(--text-secondary)' }}>
              <h4 style={{ marginBottom: '10px', color: 'var(--text-primary)', fontWeight: 800 }}>{t('drop_title') || 'GaiaDrop Secure Inbox'}</h4>
              <p style={{ fontSize: '0.85rem', lineHeight: '1.5', marginBottom: '15px' }}>
                {t('drop_desc') || 'Ein Zero-Knowledge-Drop-Kanal für anonyme externe Zusendungen. Externe Personen können dir über den GaiaDrop-Bereich auf der Login-Seite sichere Nachrichten senden, ohne selbst einen Account zu besitzen.'}
              </p>
              <div style={{ padding: '12px', background: 'rgba(255,255,255,0.02)', borderRadius: '6px', fontSize: '0.8rem', border: '1px solid var(--border-color)' }}>
                <strong>Wie empfange ich Drops?</strong>
                <ol style={{ paddingLeft: '20px', marginTop: '6px', lineHeight: '1.4' }}>
                  <li>Teile deine GaiaID (z. B. <code style={{ color: 'var(--accent-cyan)' }}>{activeIdentity ? displayGaiaID(activeIdentity.GaiaID) : 'deine_adresse'}</code>) mit Tippgebern.</li>
                  <li>Diese rufen die Login-Seite auf, wechseln zum Reiter "GaiaDrop" und senden ihre Nachricht.</li>
                  <li>Klicke oben auf "Laden / Entschlüsseln", um die eingegangenen Meldungen abzurufen und clientseitig zu dekodieren.</li>
                </ol>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default DropPane;
